import { render, staticRenderFns } from "./CameraScreenSetting.vue?vue&type=template&id=745972ed&scoped=true&"
import script from "./CameraScreenSetting.vue?vue&type=script&lang=js&"
export * from "./CameraScreenSetting.vue?vue&type=script&lang=js&"
import style0 from "./CameraScreenSetting.vue?vue&type=style&index=0&id=745972ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745972ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745972ed')) {
      api.createRecord('745972ed', component.options)
    } else {
      api.reload('745972ed', component.options)
    }
    module.hot.accept("./CameraScreenSetting.vue?vue&type=template&id=745972ed&scoped=true&", function () {
      api.rerender('745972ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/DeviceSetting/coordi/CameraScreenSetting.vue"
export default component.exports